import React from "react";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import MiscellaneousServicesOutlinedIcon from "@mui/icons-material/MiscellaneousServicesOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("IsLoggedIn");

    navigate("/admin/login", {
      state: { message: "Logged out successfully." },
    });
  };
  return (
    <div className="sidebar-content py-7 px-5">
      <div className="sidebar-logo">
        <h1 className="text-center text-2xl font-bold text-white">AGA CRANE</h1>
      </div>

      <div className="sidebar-navigation mt-6">
        <ul>
          <div className="sidebar-link">
            <Link
              to="/admin/dashboard"
              className={
                location.pathname === "/admin/dashboard" ? "active" : ""
              }
            >
              <SpaceDashboardOutlinedIcon
                sx={{ fontSize: "20px", marginRight: "15px" }}
              />
              Dashboard
            </Link>
          </div>
          <div className="sidebar-link">
            <Link
              to="/admin/dashboard/products"
              className={
                location.pathname === "/admin/dashboard/products"
                  ? "active"
                  : ""
              }
            >
              <CategoryOutlinedIcon
                sx={{ fontSize: "20px", marginRight: "15px" }}
              />
              Inventory
            </Link>
          </div>
          <div className="sidebar-link">
            <Link
              to="/admin/dashboard/interests"
              className={
                location.pathname === "/admin/dashboard/interests"
                  ? "active"
                  : ""
              }
            >
              <MiscellaneousServicesOutlinedIcon
                sx={{ fontSize: "20px", marginRight: "15px" }}
              />
              Interested Peoples
            </Link>
          </div>
          <div className="sidebar-link">
            <Link
              to="/admin/dashboard/customers"
              className={
                location.pathname === "/admin/dashboard/customers"
                  ? "active"
                  : ""
              }
            >
              <ContactsOutlinedIcon
                sx={{ fontSize: "20px", marginRight: "15px" }}
              />
              AGA Customers
            </Link>
          </div>

          <div className="sidebar-link">
            <button className="logout" onClick={handleLogout}>
              <LogoutOutlinedIcon
                sx={{ fontSize: "20px", marginRight: "15px" }}
              />
              Logout
            </button>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
